export type ToolStateOption = {
  value: string;
  labelKey: string;
};

export type ToolChangeOption = {
  value: string;
  labelKey: string;
};

export const toolState: ToolStateOption[] = [
  { labelKey: 'traceability.breakTab.stateOptions.new', value: 'new' },
  { labelKey: 'traceability.breakTab.stateOptions.worn', value: 'worn' },
  { labelKey: 'traceability.breakTab.stateOptions.broken', value: 'broken' },
  { labelKey: 'traceability.breakTab.stateOptions.unknown', value: 'unknown' },
];

export const toolChange: ToolChangeOption[] = [
  {
    labelKey: 'traceability.breakTab.reasonOptions.completeBrokenTool',
    value: 'complete_broken_tool',
  },
  { labelKey: 'traceability.breakTab.reasonOptions.brokenTeeth', value: 'broken_teeth' },
  { labelKey: 'traceability.breakTab.reasonOptions.brokenPart', value: 'broken_part' },
  { labelKey: 'traceability.breakTab.reasonOptions.burr', value: 'bavure' },
  { labelKey: 'traceability.breakTab.reasonOptions.badSurface', value: 'bad_surface' },
  { labelKey: 'traceability.breakTab.reasonOptions.badDimension', value: 'bad_dimension' },
  { labelKey: 'traceability.breakTab.reasonOptions.endOfSeries', value: 'end_of_serie' },
  { labelKey: 'traceability.breakTab.reasonOptions.productionStop', value: 'production_stop' },
  { labelKey: 'traceability.breakTab.reasonOptions.noise', value: 'noise' },
  { labelKey: 'traceability.breakTab.reasonOptions.maxToolLife', value: 'max_tool_life' },
  { labelKey: 'traceability.breakTab.reasonOptions.partAppearance', value: 'part_aspect' },
  { labelKey: 'traceability.breakTab.reasonOptions.vibration', value: 'vibration' },
  { labelKey: 'traceability.breakTab.reasonOptions.other', value: 'autre' },
];
